/* import __COLOCATED_TEMPLATE__ from './user-api-keys.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./user-api-keys.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());